const onlyAllowedSpecialCharacters = (value: string): boolean => {
  return /^[åäöÅÄÖ\w\/<>_~@$%^&*+=`|{}:;!.,?"\\\[\]]+$/.test(value);
};

export default onlyAllowedSpecialCharacters;
